// ~/services/authService.ts

import type {
  ILogoutResponse,
  LoginResponse,
  RefreshTokenResponse,
} from "~/types/auth";
import apiClient from "./apiClient";
import type { ApiResponse } from "~/types/apiResponse";
import { apiRoutes } from "~/routes";
import type { LoginRequest } from "~/schemas/login.schema";
import type { InitRegistrationrequest } from "~/schemas/initRegistration.schema";

export const authService = async () => {
  const api = await apiClient();
  /**
   * Login user with credentials
   */
  const login = async (
    credentials: LoginRequest,
  ): Promise<ApiResponse<LoginResponse>> => {
    return api.auth.post(apiRoutes.login.path, { ...credentials });
  };

  /**
   * Login user with credentials
   */
  const register = async (
    registerData: InitRegistrationrequest,
  ): Promise<ApiResponse<LoginResponse>> => {
    return api.auth.post(apiRoutes.register.initRegistration, {
      ...registerData,
    });
  };

  /**
   * Refresh access token using httpOnly cookie
   */
  const refreshToken = async (): Promise<ApiResponse<RefreshTokenResponse>> => {
    return api.auth.post<RefreshTokenResponse>(apiRoutes.refreshToken.path);
  };

  /**
   * Logout user
   */
  const logout = async () => {
    return api.auth.post<ILogoutResponse>(apiRoutes.logout.path);
  };

  return {
    login,
    register,
    refreshToken,
    logout,
  };
};
